import { PubNubService } from "src/app/core/services/pubnub.service";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Subscription } from "rxjs";
import { CommanSubscribeService } from "src/app/core/services/comman-subscribe.service";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { StorageService } from "./../../../../../core/services/storage.service";
import { environment } from "src/environments/environment";
import { CONST_AWS_API, API } from "../../../../../core/constants";
import { API as AWS_API } from "aws-amplify";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { AppService } from "./../../../../../core/services/app.service";
import { LandingPageService } from "./../../../../../core/services/landing-page.service";
import { ToastrService } from "ngx-toastr";
import { UserService } from "src/app/core/services/user.service";
import { Web3Service } from "src/app/core/services/web3.service";

@Component({
  selector: "app-event-nav",
  templateUrl: "./event-nav.component.html",
  styleUrls: ["./event-nav.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class EventNavComponent implements OnInit {
  userInfo: any = {};
  userInfoSubscription: Subscription;
  loggedIn: boolean = false;
  displayName = "";
  profileName = "";
  userIdParam: any;
  currenciesList: any = [];
  currency: any;
  currentLocation: any;
  screenStatusSubscription: Subscription;
  leftMenu: boolean = false;
  isPubNubChannelAvailable: Boolean;
  event_id = 0;
  openPubNubChannel: any;
  messageSubscriber: any;
  ticket_key: any;
  routerevents: Subscription;
  user_id: any;
  inviteKey = "";
  isNetworkNotification = false;
  linkUrl: string;
  message: any;
  ticketStatus: any;
  paymentStatusSubscription: Subscription;
  paymentStatus: boolean = false;
  searchCurrency: any = "";
  currencyJSON: any = [];
  getCurrency: any;
  slugInfoSubscr: Subscription;
  slugInfo: any;
  streamInfo: any;
  affiliateInfo: any;
  performerStatusSubscription: Subscription;
  performerStatus: any = false;
  assets_url = environment.assets_url;
  clientDetails: any;
  isCryptoWallet = environment.required_crypto_wallet;

  get channelName(): string { return this.router.url.split('/')[1] || ''; }

  constructor(
    private commonSubscribeService: CommanSubscribeService,
    private router: Router,
    private storageService: StorageService,
    private ngxLoader: NgxUiLoaderService,
    private appService: AppService,
    private landingPageService: LandingPageService,
    private toastr: ToastrService,
    private userService: UserService,
    private PubnubService: PubNubService,
    public route: ActivatedRoute,
    private web3service: Web3Service
  ) {
    this.routerevents = router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (
          this.route &&
          this.route.firstChild &&
          this.route.firstChild.paramMap
        ) {
          this.route.firstChild.paramMap.subscribe((params: any): void => {
            let eventId;
            // this.slug_name = this.slugInfo && this.slugInfo.slug ? this.slugInfo.slug : params.params['slug_name'];
            this.ticket_key = params.params["ticket_key"]
              ? params.params["ticket_key"]
              : params.params["eventId"];
            if (
              !this.storageService.getItem("ticket_key") &&
              this.ticket_key != undefined
            ) {
              this.storageService.setItem("ticket_key", this.ticket_key);
              let id = this.ticket_key;
              if (id && id.includes("-")) eventId = id.split("-");
            }
            if (eventId)
              this.event_id = eventId ? eventId[0] : params.params["id"];
            this.connectChannel();
          });
        }
      }
    });
    // this.ticketStatus = this.userService.getTicketStatus().subscribe(response => {
    //   if (response) {
    //     this.connectChannel();
    //   }
    // });
  }
  connectChannel() {
    if (this.storageService.getItem("ticket_key")) {
      this.ticket_key = this.storageService.getItem("ticket_key");
      this.event_id = this.ticket_key.split("-")[0];
    }
    if (this.ticket_key) {
      this.event_id = this.ticket_key ? this.ticket_key.split("-")[0] : 0;
      this.user_id = this.ticket_key ? this.ticket_key.split("-")[1] : 0;
    }
    console.log("ticket_key :: ", this.ticket_key);
    this.PubnubService.init();
    if (this.user_id && this.event_id) this.connectPubNubChannels();
  }
  ngOnInit() {
    this.clientDetails = environment.clientDetails;
    this.performerStatusSubscription = this.commonSubscribeService
      .getPerformerStatus()
      .subscribe((response) => {
        this.performerStatus = response;
      });

    this.screenStatusSubscription = this.commonSubscribeService
      .getScreenStatus()
      .subscribe((response) => {
        this.leftMenu = response;
      });
    this.paymentStatusSubscription = this.commonSubscribeService
      .getPaymentStatus()
      .subscribe((response) => {
        this.paymentStatus = response;
      });
    this.userInfo = this.commonSubscribeService.userInfo;
    this.getName();
    this.commonSubscribeService.getCurrenciesJSON().subscribe((result) => {
      Object.keys(result).forEach((element) => {
        let value = element + " - " + result[element];
        this.currencyJSON.push({ currency: value });
        this.currenciesList.push(value);
      });
    });
    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation =
      locInfo && Object.keys(locInfo).length > 0
        ? locInfo
        : this.storageService.getItem("current_location");
    this.getCurrency = this.storageService.getItem("currency");
    if (
      !this.currentLocation ||
      Object.keys(this.currentLocation).length == 0
    ) {
      this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
        console.log(json);
        if (val == "fail") {
          this.currentLocation = this.currentLocation
            ? this.currentLocation
            : {};
        } else {
          this.currentLocation = json;
          if (
            this.currentLocation &&
            this.currentLocation.currency &&
            (Object.keys(this.route.snapshot.queryParams).length == 0 ||
              (Object.keys(this.route.snapshot.queryParams).length > 0 &&
                !this.route.snapshot.queryParams.currency))
          ) {
            setTimeout(() => {
              this.setCurrency();
            }, 1000);
          }
        }
      });
    } else {
      if (
        this.currentLocation &&
        this.currentLocation.currency &&
        (Object.keys(this.route.snapshot.queryParams).length == 0 ||
          (Object.keys(this.route.snapshot.queryParams).length > 0 &&
            !this.route.snapshot.queryParams.currency))
      ) {
        setTimeout(() => {
          this.setCurrency();
        }, 1000);
      } else {
        setTimeout(() => {
          this.setCurrency();
        }, 1000);
      }
    }
    this.userInfoSubscription = this.commonSubscribeService
      .getUserInfo()
      .subscribe((response) => {
        this.userInfo = response;
        this.getName();
        let userInfo = this.storageService.getItem("user_Info");
        if (
          userInfo &&
          userInfo.access_token &&
          this.userInfo &&
          this.userInfo.id
        ) {
          this.loggedIn = true;
        } else {
          this.loggedIn = false;
        }
      });
    let userInfo = this.storageService.getItem("user_Info");
    if (
      userInfo &&
      userInfo.access_token &&
      this.userInfo &&
      this.userInfo.id
    ) {
      this.loggedIn = true;
    }
    this.userIdParam = this.route.snapshot.queryParamMap.get("user_id");
    // if (this.event_id != 0 && this.user_id && !this.router.url.includes('network-room')) {
    //   this.connectChannel();
    // }

    this.slugInfo = this.commonSubscribeService.slugInfo;
    this.slugInfoSubscr = this.commonSubscribeService
      .getSlugData()
      .subscribe((response) => {
        this.slugInfo = response;
        if (response && response.affiliates && response.affiliates.length > 0) {
          let aff = response.affiliates.filter(
            (a) => a.referral_code == this.route.snapshot.queryParams.ref
          );
          if (aff.length > 0) {
            this.affiliateInfo = aff[0];
          }
          if (
            response.user_subscription_info &&
            response.user_subscription_info.length > 0
          ) {
            if (response.user_subscription_info[0].referrer_code) {
              let aff = response.affiliates.filter(
                (a) =>
                  a.referral_code ==
                  response.user_subscription_info[0].referrer_code
              );
              if (aff.length > 0) {
                this.affiliateInfo = aff[0];
              }
            }
          }
        }
        this.streamInfo = this.slugInfo.stream_info
          ? this.slugInfo.stream_info
          : this.slugInfo;
        if (this.streamInfo.media_files) {
          let media_files = JSON.parse(this.streamInfo.media_files);
          Object.keys(media_files).forEach((element) => {
            this.streamInfo[element] = media_files[element];
          });
        }
      });
  }

  setCurrency() {
    let cur =
      Object.keys(this.route.snapshot.queryParams).length > 0 &&
      this.route.snapshot.queryParams.currency
        ? this.route.snapshot.queryParams.currency
        : this.getCurrency;
    this.currenciesList.forEach((element) => {
      let getVal = element.split(" -");
      let code = cur
        ? cur
        : this.currentLocation.currency.code.includes('"')
        ? JSON.parse(this.currentLocation.currency.code)
        : this.currentLocation.currency.code;
      if (getVal[0] == code) {
        this.currency = element;
        this.storageService.setItem("currency", getVal[0]);
        // this.commonSubscribeService.sendCurrencyInfo(getVal[0]);
      }
    });
  }

  clearSearch() {
    this.searchCurrency = "";
  }

  toggleMenu: boolean = false;
  sideMenu() {
    this.toggleMenu = !this.toggleMenu;
  }

  getName() {
    if (this.userInfo) {
      if (this.userInfo.user_display_name) {
        let name;
        if (
          this.userInfo.user_display_name &&
          this.userInfo.user_display_name.includes(" ")
        ) {
          name = this.userInfo.user_display_name.split(" ");
          if (name[0] && !name[1] && name[1] != "") {
            this.displayName = name[0][0] + name[0][1];
          } else if (name[1][0] != undefined) {
            this.displayName = name[0][0] + (name[2] ? name[2][0] : name[1][0]);
          } else {
            this.displayName = this.userInfo.user_display_name[0];
          }
        } else if (this.userInfo.user_display_name[1] != undefined) {
          this.displayName =
            this.userInfo.user_display_name[0] +
            this.userInfo.user_display_name[1];
        } else {
          this.displayName = this.userInfo.user_display_name[0];
        }
        // this.displayName = this.userInfo.user_first_name[0] + this.userInfo.user_last_name[0];
        this.profileName = this.userInfo.user_display_name;
        // this.profileName = this.userInfo.user_first_name + " " + this.userInfo.user_last_name;
      } else if (this.userInfo.user_first_name) {
        this.displayName =
          this.userInfo.user_first_name[0] + this.userInfo.user_first_name[1];
        this.profileName = this.userInfo.user_first_name;
      } else if (this.userInfo.user_email) {
        this.displayName =
          this.userInfo.user_email[0] + this.userInfo.user_email[1];
      }
    }
  }
  gotoCommunities() {
    this.router.navigate(["/communities"]); 
  }

  goToMainScreen() {
    this.storageService.deleteItem("eventInfo");
    this.storageService.deleteItem("isEvent");
    if (
      this.streamInfo &&
      this.streamInfo.channel_display_name &&
      this.performerStatus
    ) {
      if (this.streamInfo.channel_name && !this.streamInfo.subchannel_name) {
        this.router.navigateByUrl("/" + `${this.streamInfo.channel_name}`);
      }
      if (this.streamInfo.channel_name && this.streamInfo.subchannel_name) {
        this.router.navigateByUrl(
          "/" +
            `${this.streamInfo.channel_name}` +
            "/channel/" +
            `${this.streamInfo.subchannel_name}`
        );
      }
    } else {
      if (
        this.userInfo &&
        (this.userInfo.signedIn || this.userInfo.id) &&
        !this.userInfo.is_guest &&
        !this.performerStatus
      ) {
        this.router.navigateByUrl("/" + this.channelName);
      } else {
        this.router.navigateByUrl("");
      }
    }
  }

  redirectTo(path) {
    if (path != "signin" && path != "signup")
      this.storageService.deleteItem("eventInfo");
    this.storageService.deleteItem("isEvent");
    // this.sidenav.close();
    if (path == "signin") this.landingPageService.openConsumerSignIn();
    else this.router.navigateByUrl(path);
  }

  signout() {
    this.storageService.deleteItem("eventInfo");
    this.storageService.deleteItem("isEvent");
    this.storageService.deleteItem("ticket_key");
    this.ngxLoader.start();
    this.appService.postRequest(API.FAN_LOGOUT, "").subscribe(
      (result) => {
        this.ngxLoader.stop();
        if (result["status"] == 0) {
          this.loggedIn = false;
           localStorage.isFanLoginUser =false;
          // this.storageService.deleteItem("userInfo");
          this.storageService.deleteItem("isAffiliateUser");
          this.storageService.deleteItem("user_Info");
          this.storageService.deleteItem("eventInfo");
          this.commonSubscribeService.sendTriggeredEvent({ actionType: 'sign-out', actionName: 'USER_LOGOUT', organizationId: this.commonSubscribeService.orgId || null });
          this.commonSubscribeService.sendUserInfo({});
          this.commonSubscribeService.sendMylistData([]);
          this.userInfo = {};
          this.web3service.signout();

        this.storageService.deleteItem("signInRouteData");
        sessionStorage.removeItem('oidcAttempted');
        this.storageService.deleteItem("redirectUrlAfterGoogleLogin");
        // Step 3: Trigger OneLogin logout (OIDC)
          const ONELOGIN_DOMAIN = `${environment.OIDC.onelogin_account_name}.onelogin.com`;//environment.onelogin_domain;
          const POST_LOGOUT_REDIRECT_URI = environment.social_auth_redirect_uri;
          // const POST_LOGOUT_REDIRECT_URI = "http://localhost:4200/";
          const ID_TOKEN = localStorage.getItem("id_token");

          if (ID_TOKEN) {
            const formattedIdToken = ID_TOKEN.replace(/^"|"$/g, ""); // remove extra quotes
            const logoutUrl =
              `https://${ONELOGIN_DOMAIN}/oidc/2/logout` +
              `?id_token_hint=${encodeURIComponent(formattedIdToken)}` +
              `&post_logout_redirect_uri=${encodeURIComponent(POST_LOGOUT_REDIRECT_URI)}`;

            window.location.href = logoutUrl; // redirect to OneLogin logout page
          } else {
            localStorage.clear();
            this.router.navigateByUrl("");
          }


        } else {
          this.ngxLoader.stop();
          this.toastr.error(result["message"]);
        }
        // this.message = result.message;
      },
      (error) => {
        this.ngxLoader.stop();
        console.log(error);
      }
    );
  }

  changeCurrency(event) {
    let getVal = event.split(" -");
    this.currency = event;
    this.storageService.setItem("currency", getVal[0]);
    this.commonSubscribeService.sendCurrencyInfo(getVal[0]);
  }

  connectPubNubChannels() {
    this.PubnubService.connect(this.user_id.toString(), (success, error) => {
      if (error) {
        console.log("Error while connecting chat user", error);
        this.isPubNubChannelAvailable = false;
        // this.toastr.error("Error while connecting chat user");
        return;
      } else {
        this.PubnubService.enterChannel(
          this.event_id + "_notifications",
          1,
          (openChannel, error) => {
            if (error) {
              this.isPubNubChannelAvailable = false;
              return;
            }
            this.isPubNubChannelAvailable = true;
            this.openPubNubChannel = openChannel;
            setTimeout(() => {
              this.subscriberChannel();
            }, 1000);
          }
        );
      }
    });
  }

  subscriberChannel() {
    this.PubnubService.receiveMessages(
      this.event_id + "_notifications",
      (response) => {
        let channel = response.channel;
        let message = response.message;
        if (
          channel &&
          this.openPubNubChannel &&
          channel == this.openPubNubChannel &&
          message.customType == "NETWORKING" &&
          message.data != "" &&
          !this.router.url.includes("network-room")
        ) {
          this.isNetworkNotification = true;
          let data = JSON.parse(message.data);
          this.message = message.message;
          this.inviteKey =
            environment.CONSUMER_PORTAL +
            `${this.commonSubscribeService.getBasePathFromUrl(this.router.url)}/event/networking-list/` +
            this.ticket_key +
            "/" +
            data.id;
          console.log("this.isNetworkNotification", this.isNetworkNotification);
          setTimeout(() => {
            this.closeBox();
          }, 10000);
        }
        if (
          channel &&
          this.openPubNubChannel &&
          channel == this.openPubNubChannel &&
          message.customType == "LiveStream" &&
          message.data != ""
        ) {
          let data = JSON.parse(message.data);
          this.commonSubscribeService.sendCurrentStreamStatus(data);
          console.log(data, "test");
        }
      }
    );
  }

  closeBox() {
    this.isNetworkNotification = false;
  }
  copyToClipboard(type) {
    // if (this.eventInfo.publish == 1) {
    const el = document.createElement("textarea");
    el.value = this.inviteKey;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    this.isNetworkNotification = false;
    this.toastr.success("Copied..!");
    // } else {
    //   this.toastr.info('Please publish the event');
    // }
  }
  joinUrl() {
    this.isNetworkNotification = false;
    window.open(this.inviteKey, "_blank");
  }
  ngOnDestroy() {
    this.PubnubService.disconnect([this.event_id + "_notifications"]);
    if (this.userInfoSubscription) this.userInfoSubscription.unsubscribe();
    if (this.screenStatusSubscription)
      this.screenStatusSubscription.unsubscribe();
    if (this.ticketStatus) this.ticketStatus.unsubscribe();
    if (this.paymentStatusSubscription)
      this.paymentStatusSubscription.unsubscribe();
    if (this.slugInfoSubscr) this.slugInfoSubscr.unsubscribe();
    if (this.performerStatusSubscription)
      this.performerStatusSubscription.unsubscribe();
  }
}
